import { CapsuleRiskScoresColors } from "../constants";

// Extra-Capsular Risk score thresholds
const CRM_ECE_RISK_HIGH_VALUE = 18; // Score > 18 = high risk
const CRM_ECE_RISK_LOW_VALUE = 3.5; // Score < 3.5 = low risk

// Determine the prostate cartoon's stroke color based on the ECE risk score
export function getStrokeColor(score) {
    if (!score) {
        return CapsuleRiskScoresColors.PROSTATE_LOW;
    }

    if (score > CRM_ECE_RISK_HIGH_VALUE) {
        return CapsuleRiskScoresColors.PROSTATE_HIGH;
    } else if (score > CRM_ECE_RISK_LOW_VALUE) {
        return CapsuleRiskScoresColors.PROSTATE_MID;
    } else {
        return CapsuleRiskScoresColors.PROSTATE_LOW;
    }
}
